export default __webpack_public_path__ + "static/media/Homepage1.c116696e.jpeg";